import { IconButton, Spinner, Tooltip } from '@chakra-ui/react';
import { LuEye } from 'react-icons/lu';

import StatusPillCellRenderer from '../components/StatusPillCellRenderer';
import GroupCellRenderer from './GroupCellRenderer';
import { getChunkStatusLabel } from './ChunkSummaryTable.utils';

export const DEFAULT_CHUNK_SUMMARY_COL_DEF = {
    sortable: false,
    filter: false,
    resizable: true,
    suppressMovable: true,
    suppressHeaderMenuButton: true,
};

export function getChunkSummaryRowData(chunkResults) {
    return chunkResults.map((chunk) => {
        const statusLabel = getChunkStatusLabel(chunk);
        const rangeLabel =
            chunk.range.start === chunk.range.end
                ? chunk.range.start
                : `${chunk.range.start} — ${chunk.range.end}`;

        return { ...chunk, rangeLabel, statusLabel };
    });
}

export function getChunkSummaryColumnDefs(onViewChunk) {
    return [
        {
            headerName: 'Group',
            field: 'rangeLabel',
            flex: 2,
            cellRenderer: GroupCellRenderer,
        },
        {
            headerName: 'Total Blocks',
            field: 'total',
            flex: 1,
            minWidth: 130,
        },
        {
            headerName: 'Status',
            field: 'statusLabel',
            flex: 1,
            minWidth: 130,
            cellRenderer: StatusPillCellRenderer,
            cellStyle: { display: 'flex', alignItems: 'center' },
        },
        {
            headerName: 'Action',
            field: 'chunkIndex',
            flex: 0.5,
            minWidth: 100,
            cellStyle: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            cellRenderer: ({ data }) =>
                data.httpStatus === null ? (
                    <Spinner size="xs" color="gray.400" />
                ) : (
                    <Tooltip label="View Detail" hasArrow placement="top">
                        <IconButton
                            aria-label="View Detail"
                            icon={<LuEye />}
                            size="xs"
                            variant="unstyled"
                            _hover={{ color: 'messenger.500' }}
                            onClick={() => onViewChunk(data.chunkIndex)}
                        />
                    </Tooltip>
                ),
        },
    ];
}
